<div class="side-nav" sideBar>
  <div [class.hidden]="!isLoggedIn" class="side-nav-inner">
    <div class="side-nav-logo">
      <a [routerLink]="['/msop/customers']" href="">
        <div
          class="logo logo-dark"
          style="background-image: url('assets/images/logo/ElevateLogo.png')"
        ></div>
        <div
          class="logo logo-white"
          style="background-image: url('assets/images/logo/ElevateLogo.png')"
        ></div>
      </a>
      <div class="mobile-toggle side-nav-toggle">
        <a (click)="toggleSideNavCollapse()" href="javascript:void(0);">
          <i class="ti-arrow-circle-left"></i>
        </a>
      </div>
    </div>
    <ul
      [class.hidden]="
        (accessApi | isUser : 'agent') ||
        (accessApi | isUser : 'dealer') ||
        (accessApi | isUser : 'oem') ||
        (accessApi | isUser : 'rent-a-wheel') ||
        (accessApi | isUser : 'fauxbox-user') ||
        (accessApi | isUser : 'fauxbox-tester')
      "
      class="side-nav-menu scrollable"
    >
      <!-- <li
        [class.hidden]="!(accessApi | isUser : 'developer')"
        class="nav-item"
        routerLinkActive="active"
      >
        <a [routerLink]="['/dashboard']" class="mrg-top-30" href="">
          <span class="icon-holder"><i class="ti-home"></i></span>
          <span class="title">Dashboard</span>
        </a>
      </li> -->

      <li class="nav-item dropdown">
        <a
          class="dropdown-toggle"
          href="javascript:void(0);"
          [class.hidden]="accessApi | isUser : 'sales'"
          [routerLink]="['/audience/dashboard']"
        >
          <span class="icon-holder"><i class="fas fa-magic"></i></span>
          <span class="title">Audience</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/reports/wizard-assessments']" href=""
              >Assessments</a
            >
          </li>
        </ul>
      </li>

      <li class="nav-item" routerLinkActive="active">
        <a
          [class.hidden]="!(accessApi | isUser : 'sales')"
          [routerLink]="['/audience/dashboard']"
          class=""
          href=""
        >
          <span class="icon-holder"><i class="fas fa-magic"></i></span>
          <span class="title">Campaign Wizard</span>
        </a>
      </li>

      <li class="nav-item dropdown">
        <a
          class="dropdown-toggle"
          href="javascript:void(0);"
          [routerLink]="['/msop/customers']"
        >
          <span class="icon-holder"><i class="fas fa-user-tie"></i></span>
          <span class="title">Accounts</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <!-- <li [class.hidden]="accessApi | isUser : 'babcox'">
            <a [routerLink]="['/omt/hubspot-active-accounts']" href=""
              >Hubspot Account Report</a
            >
          </li> -->
          <li>
            <a [routerLink]="['/reports/kpi-overview']" href=""
              >KPI Report Page</a
            >
          </li>
          <li>
            <a [routerLink]="['/omt/jo-cat-report']" href="">Matching Report</a>
          </li>
          <!--          <li><a [routerLink]="['/omt/cat-report']" href="">Cat Report</a></li>-->
          <!--          <li><a [routerLink]="['/omt/efo-matching']" href="">Sales Matching</a></li>-->
          <!--          <li><a [routerLink]="['/omt/efo-matching-service']" href="">Service Matching</a></li>-->
          <li>
            <a [routerLink]="['/reports/target-list-update']" href=""
              >Target List Update</a
            >
          </li>
          <li>
            <a [routerLink]="['/reports/active-dms-crm']" href=""
              >Active Connections</a
            >
          </li>
          <li>
            <a [routerLink]="['/reports/creative-sched']" href=""
              >Creative Schedule</a
            >
          </li>
          <!-- <li [class.hidden]="accessApi | isUser : 'babcox'">
            <a [routerLink]="['/omt/efo-matching-crm-account']" href=""
              >CRM Matching</a
            >
          </li>
          <li [class.hidden]="accessApi | isUser : 'babcox'">
            <a
              [routerLink]="['/system-monitoring/monitoring/account-statuses']"
              href=""
              >Account Statuses</a
            >
          </li> -->
          <!-- <li [class.hidden]="accessApi | isUser : 'babcox'">
            <a [routerLink]="['/reports/reports-list']" href=""
              >Account Reports</a
            >
          </li> -->
        </ul>
      </li>
      <li [class.hidden]="true" class="nav-item" routerLinkActive="active">
        <a [routerLink]="['/msop/customers']" class="" href="">
          <span class="icon-holder"><i class="fa fa-user"></i></span>
          <span class="title">Accounts</span>
        </a>
      </li>
      <li [class.hidden]="true" class="nav-item" routerLinkActive="active">
        <a [routerLink]="['/msop/campaigns']" class="" href="">
          <span class="icon-holder"><i class="fa fa-map"></i></span>
          <span class="title">Campaigns</span>
        </a>
      </li>
      <li clas="nav-item" routerLinkActive="active">
        <a
          [class.hidden]="!(accessApi | isUser : 'admin')"
          [routerLink]="['/audience/dealers']"
          class=""
          href=""
        >
          <span class="icon-holder"><i class="fa fa-users"></i></span>
          <span class="title">Dealers</span>
        </a>
      </li>
      <li
        [class.hidden]="accessApi | isUser : 'babcox'"
        clas="nav-item"
        routerLinkActive="active"
      >
        <a [routerLink]="['/omt/menu']" class="" href="">
          <span class="icon-holder"><i class="fas fa-boxes"></i></span>
          <span class="title">OMT</span>
        </a>
      </li>
      <li
        [class.hidden]="!(accessApi | isUser : 'admin')"
        class="nav-item"
        routerLinkActive="active"
      >
        <a
          [routerLink]="['/system-monitoring/monitoring/account-statuses']"
          class=""
          href=""
        >
          <span class="icon-holder"><i class="fas fa-procedures"></i></span>
          <span class="title">System Monitoring</span>
        </a>
      </li>
      <!-- <li
        [class.hidden]="!(accessApi | isUser : 'mike-schreiber')"
        class="nav-item"
        routerLinkActive="active"
      >
        <a [routerLink]="['/reports/reports-list']" class="" href="">
          <span class="icon-holder"><i class="fas fa-table"></i></span>
          <span class="title">System Reports</span>
        </a>
      </li> -->
      <li
        [class.hidden]="!(accessApi | isUser : 'developer')"
        class="nav-item"
        routerLinkActive="active"
      >
        <a [routerLink]="['/facebook/summary']" class="" href="">
          <span class="icon-holder"
            ><i class="fab fa-facebook-square"></i
          ></span>
          <span class="title">Facebook</span>
        </a>
      </li>
      <li class="nav-item dropdown">
        <a
          class="dropdown-toggle"
          href="javascript:void(0);"
          [routerLink]="['/robomail/robomail-kpi']"
        >
          <span class="icon-holder"><i class="fas fa-robot"></i></span>
          <span class="title">Robomail</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li
            [class.hidden]="!(accessApi | isUser : 'developer')"
            class="nav-item"
            routerLinkActive="active"
          >
            <a [routerLink]="['/robomail/reporting-sqls']" class="" href="">
              Robomail SQLs
            </a>
          </li>
        </ul>

        <!-- <li
        [class.hidden]="
          !(
            (accessApi | isUser : 'mike-schreiber') ||
            (accessApi | isUser : 'admin')
          )
        "
        class="nav-item dropdown"
      >
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"
            ><i class="fab fa-facebook-square"></i
          ></span>
          <span class="title">Facebook</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/facebook/fb-menu']" href="">Facebook Menu</a>
          </li>
          <li>
            <a [routerLink]="['/facebook/adaccounts']" href=""
              >Facebook Accounts</a
            >
          </li>
          <li>
            <a [routerLink]="['/facebook/upload-status']" href=""
              >Upload Status</a
            >
          </li>
          <li>
            <a [routerLink]="['/facebook/match-summary']" href=""
              >Match Summary</a
            >
          </li>
          <li>
            <a
              [routerLink]="['/facebook/dealer-inventory/', 'R84275994']"
              href=""
              >Inventory</a
            >
          </li>
          <li>
            <a [routerLink]="['/facebook/inventory-extractor']" href=""
              >Inventory Extractor</a
            >
          </li>
          <li>
            <a [routerLink]="['/facebook/link-checker']" href=""
              >Link Checker</a
            >
          </li>
        </ul>
      </li> -->
        <!-- <li
        [class.hidden]="
          !(
            (accessApi | isUser : 'beta-user') ||
            (accessApi | isUser : 'mike-schreiber')
          )
        "
        class="nav-item dropdown"
        routerLinkActive="open"
      >
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="ti-email"></i></span>
          <span class="title">RoboMail</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/robomail/group-usage']" href=""
              >IP Group Usage</a
            >
          </li>
          <li>
            <a [routerLink]="['/robomail/mail-deliverability']" href=""
              >Mail Deliverability</a
            >
          </li>
        </ul>
      </li> -->
      </li>

      <li
        [class.hidden]="
          !(
            (accessApi | isUser : 'developer') &&
            (accessApi | isAccount : 'GrowPodium')
          )
        "
        class="nav-item dropdown"
      >
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="ti-package"></i></span>
          <span class="title">Apps</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/apps/email/email-inbox/1']" href="">Email</a>
          </li>
          <li><a [routerLink]="['/apps/calendar']" href="">Calendar</a></li>
          <li><a [routerLink]="['/apps/social']" href="">Social</a></li>
          <li><a [routerLink]="['/apps/task']" href="">Task</a></li>
        </ul>
      </li>

      <li
        [class.hidden]="
          !(accessApi | isUser : 'admin') && !(accessApi | isUser : 'sales')
        "
        class="nav-item dropdown"
      >
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-beer"></i></span>
          <span class="title">CarBrewer</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/cbr/dashboard/summary']" href="">Dashboard</a>
          </li>
          <li>
            <a [routerLink]="['/cbr/am-dealers']" href="">Dealer Management</a>
          </li>
          <li>
            <a [routerLink]="['/cbr/inventory-monitor']" href=""
              >Inventory Extraction Monitor</a
            >
          </li>
          <li>
            <a [routerLink]="['/cbr/car-search-new']" href="">Car Search</a>
          </li>
          <li><a [routerLink]="['/cbr/reports']" href="">Cbr Reports</a></li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-bullseye"></i></span>
          <span class="title">Targeting</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/audience/targeting']" href=""
              >Audience Analysis</a
            >
          </li>
          <!-- <li [class.hidden]="accessApi | isUser : 'babcox'">
            <a [routerLink]="['/audience/advanced-geo-targeting']" href=""
              >Advanced Geo Targeting</a
            >
          </li> -->
          <li>
            <a [routerLink]="['/audience/crisscross']" href=""
              >Criss Cross Targeting</a
            >
          </li>
          <li><a [routerLink]="['/audience/recalls']" href="">Recalls</a></li>
          <li>
            <a [routerLink]="['/reports/recall-sniper']" href=""
              >Recall Sniper</a
            >
          </li>
          <!-- <li>
            <a [routerLink]="['/reports/wizard-assessments']" href=""
              >Assessments</a
            >
          </li> -->
          <li [class.hidden]="accessApi | isUser : 'babcox'">
            <a [routerLink]="['/omt/campaign-export']" href=""
              >OMT Campaign Export</a
            >
          </li>
          <li [class.hidden]="accessApi | isUser : 'babcox'">
            <a [routerLink]="['/omt/targeting-report']" href=""
              >Targeting Report</a
            >
          </li>
          <li [class.hidden]="accessApi | isUser : 'babcox'">
            <a [routerLink]="['/omt/marketing-report']" href=""
              >Marketing Report</a
            >
          </li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-palette"></i></span>
          <span class="title">Creatives</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/facebook/fb-ads']" href="">Social Creatives</a>
          </li>
          <li>
            <a [routerLink]="['/facebook/fb-adimages']" href=""
              >Social Images</a
            >
          </li>
          <li>
            <a [routerLink]="['/omt/email-ads']" href="">Email Creatives</a>
          </li>
          <!-- <li>
            <a [routerLink]="['/facebook/marketplace']" href=""
              >Marketplace Creatives</a
            >
          </li> -->
        </ul>
      </li>
      <li clas="nav-item">
        <a [routerLink]="['/reports/menu']" class="" href="">
          <span class="icon-holder"><i class="fas fa-poll-h"></i></span>
          <span class="title">Reporting</span>
        </a>
      </li>

      <!-- <li class="nav-item dropdown">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fa fa-globe"></i></span>
          <span class="title">OEM Menu</span
          ><span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/audience/dealers']" href="">OEM Dealers Map</a>
          </li>
          <li>
            <a [routerLink]="['/omt/oem-matching-sales']" href=""
              >OEM Sales Report</a
            >
          </li>
          <li>
            <a [routerLink]="['/omt/oem-matching-service']" href=""
              >OEM Service Report</a
            >
          </li>
          <li>
            <a [routerLink]="['/omt/oem-matching-service']" href=""
              >OEM Creative Report</a
            >
          </li>
        </ul>
      </li> -->
      <li
        [class.hidden]="!(accessApi | isUser : 'user')"
        class="nav-item dropdown"
        routerLinkActive="active"
      >
        <a
          class="dropdown-toggle"
          [routerLink]="['/playbooks']"
          class=""
          href="javascript:void(0);"
        >
          <span class="icon-holder"><i class="fas fa-football-ball"></i> </span>
          <span class="title">Playbooks</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/playbooks/templates']" href="">Templates</a>
          </li>
        </ul>
      </li>
      <li clas="nav-item">
        <a
          [class.hidden]="!(accessApi | isUser : 'mike-schreiber')"
          [routerLink]="['/poc/menu']"
          class=""
          href=""
        >
          <span class="icon-holder"><i class="fas fa-flask"></i></span>
          <span class="title">POC Menu</span>
        </a>
      </li>
      <li
        [class.hidden]="!(accessApi | isUser : 'admin')"
        class="nav-item"
        routerLinkActive="active"
      >
        <a [routerLink]="['/admin/user-manager']" class="" href="">
          <span class="icon-holder"><i class="fa fa-cog"></i></span>
          <span class="title">User Administration</span>
        </a>
      </li>
    </ul>
    <!-- Rick-Rich Menu -->
    <!-- <ul
      [class.hidden]="!(accessApi | isUser : 'rick-rich')"
      class="side-nav-menu scrollable"
    >
      <li class="nav-item" routerLinkActive="active">
        <a class="" href="">
          <span class="icon-holder"><i class="fa fa-users"></i></span>
          <span class="title">Audience</span>
        </a>
      </li>
      <li class="nav-item"  [class.hidden]="!(accessApi | isUser : 'rick-rich')" routerLinkActive="active">
        <a [routerLink]="['/audience/upcoming-deals']" href="">
          <span class="icon-holder"><i class="fas fa-hand-point-up"></i></span>
          <span class="title">Upcoming Deals</span></a
        >
      </li> -->
    <!-- Agent Menu-->
    <ul
      [class.hidden]="!(accessApi | isUser : 'agent')"
      class="side-nav-menu scrollable"
    >
      <li class="nav-item" routerLinkActive="active">
        <a class="" href="">
          <span class="icon-holder"><i class="fa fa-users"></i></span>
          <span class="title">Audience</span>
        </a>
      </li>
      <li
        class="nav-item"
        [class.hidden]="!(accessApi | isUser : 'rick-rich')"
        routerLinkActive="active"
      >
        <a [routerLink]="['/audience/upcoming-deals']" href="">
          <span class="icon-holder"><i class="fas fa-hand-point-up"></i></span>
          <span class="title">Upcoming Deals</span></a
        >
      </li>
      <!-- <li class="nav-item" routerLinkActive="active">
        <a [routerLink]="['/reports/upcoming-deals']" href="">
          <span class="icon-holder"><i class="fas fa-hand-point-up"></i></span>
          <span class="title">Upcoming Deals</span></a
        >
      </li> -->
      <li class="nav-item dropdown hidden">
        <a
          class="dropdown-toggle"
          href="javascript:void(0);"
          [routerLink]="['/msop/customers']"
        >
          <span class="icon-holder"><i class="fa fa-user"></i></span>
          <span class="title">Accounts</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul
          [class.hidden]="!(accessApi | isUser : 'admin')"
          [ngClass]="{ hidden: !(accessApi | isUser : 'admin') }"
          class="dropdown-menu"
        >
          <li>
            <a [routerLink]="['/reports/reports-list']" href=""
              >Account Reports</a
            >
          </li>
        </ul>
      </li>
      <li class="nav-item dropdown hidden">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-poll-h"></i></span>
          <span class="title">Reports</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/fauxbox/fauxbox-account']" href="">Dashboard</a>
          </li>
        </ul>
      </li>
      <li class="nav-item dropdown hidden">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-bullseye"></i></span>
          <span class="title">Targeting</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/audience/targeting']" href=""
              >Audience Analysis</a
            >
          </li>
          <li>
            <a [routerLink]="['/audience/advanced-geo-targeting']" href=""
              >Advanced Geo Targeting</a
            >
          </li>
          <li>
            <a [routerLink]="['/audience/crisscross']" href=""
              >Criss Cross Targeting</a
            >
          </li>
          <li><a [routerLink]="['/audience/recalls']" href="">Recalls</a></li>
          <!--          <li><a [routerLink]="['/omt/campaign-export']" href="">Omt Campaign Export</a></li>-->
          <!--          <li><a [routerLink]="['/omt/targeting-report']" href="">Targeting Report</a></li>-->
          <!--          <li><a [routerLink]="['/omt/marketing-report']" href="">Marketing Report</a></li>-->
        </ul>
      </li>
      <li class="nav-item dropdown hidden">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-palette"></i></span>
          <span class="title">Creatives</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/facebook/fb-ads']" href="">Social Creatives</a>
          </li>
          <li>
            <a [routerLink]="['/facebook/fb-adimages']" href=""
              >Social Images</a
            >
          </li>
          <li>
            <a [routerLink]="['/omt/email-ads']" href="">Email Creatives</a>
          </li>
          <!--          <li><a [routerLink]="['/facebook/marketplace']" href="">Marketplace Creatives</a></li>-->
        </ul>
      </li>
    </ul>
    <!-- Dealer Menu-->
    <ul
      [class.hidden]="!(accessApi | isUser : 'dealer')"
      class="side-nav-menu scrollable"
    >
      <!-- Dealer Menu-->
      <li class="nav-item" routerLinkActive="active">
        <a class="" href="">
          <span class="icon-holder"><i class="fa fa-users"></i></span>
          <span class="title">Audience</span>
        </a>
      </li>
      <li class="nav-item dropdown">
        <a
          class="dropdown-toggle"
          href="javascript:void(0);"
          [routerLink]="['/msop/customers']"
        >
          <span class="icon-holder"><i class="fa fa-user"></i></span>
          <span class="title">Accounts</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/reports/reports-list']" href=""
              >Account Reports</a
            >
          </li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-poll-h"></i></span>
          <span class="title">Reports</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/fauxbox/fauxbox-account']" href="">Dashboard</a>
          </li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-bullseye"></i></span>
          <span class="title">Targeting</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/audience/targeting']" href=""
              >Audience Analysis</a
            >
          </li>
          <li>
            <a [routerLink]="['/audience/advanced-geo-targeting']" href=""
              >Advanced Geo Targeting</a
            >
          </li>
          <li>
            <a [routerLink]="['/audience/crisscross']" href=""
              >Criss Cross Targeting</a
            >
          </li>
          <li><a [routerLink]="['/audience/recalls']" href="">Recalls</a></li>
          <!--          <li><a [routerLink]="['/omt/campaign-export']" href="">Omt Campaign Export</a></li>-->
          <!--          <li><a [routerLink]="['/omt/targeting-report']" href="">Targeting Report</a></li>-->
          <!--          <li><a [routerLink]="['/omt/marketing-report']" href="">Marketing Report</a></li>-->
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-palette"></i></span>
          <span class="title">Creatives</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/facebook/fb-ads']" href="">Social Creatives</a>
          </li>
          <li>
            <a [routerLink]="['/facebook/fb-adimages']" href=""
              >Social Images</a
            >
          </li>
          <li>
            <a [routerLink]="['/omt/email-ads']" href="">Email Creatives</a>
          </li>
          <!--          <li><a [routerLink]="['/facebook/marketplace']" href="">Marketplace Creatives</a></li>-->
        </ul>
      </li>
    </ul>
    <!-- OEM Menu-->
    <ul
      [class.hidden]="!(accessApi | isUser : 'oem')"
      class="side-nav-menu scrollable"
    >
      <!-- OEM Menu-->
      <li class="nav-item" routerLinkActive="active">
        <a class="" href="">
          <span class="icon-holder"><i class="fa fa-users"></i></span>
          <span class="title">Audience</span>
        </a>
      </li>
      <li class="nav-item dropdown">
        <a
          class="dropdown-toggle"
          href="javascript:void(0);"
          [routerLink]="['/msop/customers']"
        >
          <span class="icon-holder"><i class="fa fa-user"></i></span>
          <span class="title">Accounts</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/reports/reports-list']" href=""
              >Account Reports</a
            >
          </li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-poll-h"></i></span>
          <span class="title">Reports</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/fauxbox/fauxbox-account']" href="">Dashboard</a>
          </li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-bullseye"></i></span>
          <span class="title">Targeting</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/audience/targeting']" href=""
              >Audience Analysis</a
            >
          </li>
          <li>
            <a [routerLink]="['/audience/advanced-geo-targeting']" href=""
              >Advanced Geo Targeting</a
            >
          </li>
          <li>
            <a [routerLink]="['/audience/crisscross']" href=""
              >Criss Cross Targeting</a
            >
          </li>
          <li><a [routerLink]="['/audience/recalls']" href="">Recalls</a></li>
          <!--          <li><a [routerLink]="['/omt/campaign-export']" href="">Omt Campaign Export</a></li>-->
          <!--          <li><a [routerLink]="['/omt/targeting-report']" href="">Targeting Report</a></li>-->
          <!--          <li><a [routerLink]="['/omt/marketing-report']" href="">Marketing Report</a></li>-->
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-palette"></i></span>
          <span class="title">Creatives</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/facebook/fb-ads']" href="">Social Creatives</a>
          </li>
          <li>
            <a [routerLink]="['/facebook/fb-adimages']" href=""
              >Social Images</a
            >
          </li>
          <li>
            <a [routerLink]="['/omt/email-ads']" href="">Email Creatives</a>
          </li>
          <!--          <li><a [routerLink]="['/facebook/marketplace']" href="">Marketplace Creatives</a></li>-->
        </ul>
      </li>
    </ul>
    <!-- Rent-A-Wheel Menu-->
    <ul
      [class.hidden]="!(accessApi | isUser : 'rent-a-wheel')"
      class="side-nav-menu scrollable"
    >
      <li class="nav-item" routerLinkActive="active">
        <a class="" href="">
          <span class="icon-holder"><i class="fa fa-users"></i></span>
          <span class="title">Wizard Demo</span>
        </a>
      </li>
      <li class="nav-item" routerLinkActive="active">
        <a [routerLink]="['/audience/rw']" class="" href="">
          <span class="icon-holder"><i class="fa fa-cog"></i></span>
          <span class="title">Locations</span>
        </a>
      </li>

      <li class="nav-item dropdown">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-bullseye"></i></span>
          <span class="title">Targeting</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/audience/targeting']" href=""
              >Audience Analysis</a
            >
          </li>
          <li>
            <a [routerLink]="['/audience/advanced-geo-targeting']" href=""
              >Advanced Geo Targeting</a
            >
          </li>
          <li>
            <a [routerLink]="['/audience/crisscross']" href=""
              >Criss Cross Targeting</a
            >
          </li>
          <li><a [routerLink]="['/audience/recalls']" href="">Recalls</a></li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-palette"></i></span>
          <span class="title">Creatives</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/facebook/fb-ads']" href="">Social Creatives</a>
          </li>
          <li>
            <a [routerLink]="['/facebook/fb-adimages']" href=""
              >Social Images</a
            >
          </li>
          <li>
            <a [routerLink]="['/omt/email-ads']" href="">Email Creatives</a>
          </li>
          <li>
            <a [routerLink]="['/facebook/marketplace']" href=""
              >Marketplace Creatives</a
            >
          </li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a class="dropdown-toggle" href="javascript:void(0);">
          <span class="icon-holder"><i class="fas fa-poll-h"></i></span>
          <span class="title">Reports</span>
          <span class="arrow"><i class="ti-angle-right"></i></span>
        </a>
        <ul class="dropdown-menu">
          <li>
            <a [routerLink]="['/fauxbox/fauxbox-account']" href="">Dashboard</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>
